import { NumberValidation } from '@rehau/shared/forms/validations/number.validation';

export class CostValidation extends NumberValidation {
  constructor() {
    super(1, 10000000);
  }
}
